export default `
query QueryClients($serviceProviderId: ID!, $from: Float!, $after: ID) {
  queryClients(from: $from, after: $after, serviceProviderId: $serviceProviderId) {
    items {
      id
      serviceProviderId
      updatedAt
      propertyIds
      firstName
      lastName
      email
      isArchived
      isDeleted
    }
    nextToken
  }
}
`;
